import { useState, useCallback, useMemo } from "react";

// Clave de persistencia en localStorage
const STORAGE_KEY = "clientesFilters";

// Opciones de estado del cliente
export const ESTADOS_CLIENTE = [
  { value: "ACTIVO", label: "Activo", color: "success" },
  { value: "INACTIVO", label: "Inactivo", color: "error" },
];

// Opciones de estado portal
export const ESTADOS_PORTAL = [
  { value: "1", label: "Portal Activo", color: "success" },
  { value: "0", label: "Sin acceso", color: "default" },
];

// Estado inicial
const INITIAL_FILTERS = {
  busqueda: "",
  estadoCliente: "",
  estadoPortal: "",
  grupo: "",
};

/**
 * Hook para manejar filtros del listado de clientes.
 * Persiste en localStorage entre sesiones.
 */
export default function useClientesFilters() {
  const [filtros, setFiltros] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved) return { ...INITIAL_FILTERS, ...JSON.parse(saved) };
    } catch {
      // silencioso — si falla localStorage, arrancamos con defaults
    }
    return INITIAL_FILTERS;
  });

  // Persistir en localStorage al cambiar
  const persistir = useCallback((nuevosFiltros) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(nuevosFiltros));
    } catch {
      // silencioso
    }
  }, []);

  const updateFiltro = useCallback(
    (campo, valor) => {
      setFiltros((prev) => {
        const next = { ...prev, [campo]: valor };
        persistir(next);
        return next;
      });
    },
    [persistir],
  );

  const limpiarFiltros = useCallback(() => {
    setFiltros(INITIAL_FILTERS);
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch {
      // silencioso
    }
  }, []);

  const removerFiltro = useCallback(
    (campo) => {
      setFiltros((prev) => {
        const next = { ...prev, [campo]: INITIAL_FILTERS[campo] };
        persistir(next);
        return next;
      });
    },
    [persistir],
  );

  // Conteo de filtros activos
  const filtrosActivos = useMemo(() => {
    let count = 0;
    if (filtros.busqueda) count++;
    if (filtros.estadoCliente) count++;
    if (filtros.estadoPortal !== "") count++;
    if (filtros.grupo) count++;
    return count;
  }, [filtros]);

  const hayFiltrosActivos = filtrosActivos > 0;

  return {
    filtros,
    filtrosActivos,
    hayFiltrosActivos,
    updateFiltro,
    limpiarFiltros,
    removerFiltro,
  };
}
